export const darkBlue = '#0074b2';
export const actionBlue = '#39AEE0';
export const lightBlue = '#00adef';
export const darkText = '#252641';
export const veryLightBlue = '#a8e1ff';
